import { AuthType, AuthField } from '../../../Authenticate/types';

export namespace utils {
  export const errorText = {
    email: 'Email Invalid',
    password: 'Password not long enough. Password must be 6 or more characters'
  };

  export const isEmpty = (field: AuthField) => field.value === '';

  export const getErrorText = (field: AuthField, type: 'email' | 'password') => {
    if (isEmpty(field)) {
      if (type === 'password') {
        return 'Please enter a password';
      } else {
        return 'Please enter an email';
      }
    } else {
      return errorText[type];
    }
  };

  export const isValidEmail = (str: string) => {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(str.toLowerCase());
  };

  export const isValidPassword = (str: string) => {
    return str.length >= 6;
  };
  export const isSubmitDisabled = (authType: AuthType, email: AuthField, password: AuthField) => {
    if (authType === 'login') {
      return isEmpty(email) || isEmpty(password);
    }
    return !isValidEmail(email.value) || !isValidPassword(password.value);
  };
}
